import api from "api"
import { AfterSignUpData } from "features/Onboarding/types"

import { OnboardingApiAdapter } from "./types"

export const b2cAdapter: OnboardingApiAdapter = {
  saveIsTeachingInSchool: async value => {
    await api.profile.updateMiscData({
      data: { currently_teaching_in_school: value },
    })
  },

  saveHasExperienceInTeaching: async value => {
    await api.profile.updateMiscData({
      data: { has_experience_in_teaching: value },
    })
  },

  saveSubjects: async (subjects, isPrimary) => {
    const promises = subjects.map(subject =>
      api.profile.subjects.create({
        data: { subjectId: subject.uuid, isPrimary },
      })
    )
    await Promise.allSettled(promises)
  },

  createSubject: async (name, userUuid) => {
    const result = await api.profile.subjects.createNew({
      data: {
        new: [{ subject: name, user_uuid: userUuid }],
      },
    })
    return result?.[0] ?? null
  },

  saveGrades: async (options, hasExperience) => {
    await api.profile.updateAdditionalData({
      data: hasExperience
        ? { grades_taught: options }
        : { grade_interests: options },
    })
  },

  saveCurricula: async curricula => {
    await api.profile.updateAdditionalData({
      data: { curricula_taught: curricula },
    })
  },
  saveTeachingLevels: async levels => {
    throw new Error("Not implemented for B2C")
  },

  saveYearsOfExperience: async value => {
    await api.profile.update({
      data: { years_of_experience: value },
    })
  },

  savePhoneNumber: async phoneNumber => {
    await api.profile.update({
      data: { phoneNumber },
    })
  },

  saveCurrentLocation: async (location: AfterSignUpData["currentLocation"]) => {
    const payload: { [key: string]: string } = {}
    if (location.city) payload.city = location.city
    if (location.state) payload.state_name = location.state
    if (location.country) payload.country_name = location.country

    await api.profile.update({ data: payload })
  },

  saveProfilePicture: async file => {
    const files = new FormData()
    files.append("picture", file)

    const res = await api.profile.update({
      data: files,
      headers: { "Content-Type": "multipart/form-data" },
    })

    if (res.isSuccessful) {
      return { pictureUrl: res.data.picture ?? null }
    }

    const errorMessage = res.errors?.message
    throw new Error(errorMessage ?? "Failed to upload profile picture")
  },
}
